export const PLAN_NAMES = {
  'wla-sprint': 'WLA Diagnostic Sprint',
  'workforce-intelligence': 'Continuous Workforce Intelligence',
};

export const HANDOFF_STORAGE_KEY = 'workplansiq.onboardingHandoff';
export const BILLING_DRAFT_STORAGE_KEY = 'workplansiq.billingAccountDraft';

export function readHandoff(searchParams) {
  // `plan` remains supported for previously shared handoff URLs.
  const plan = searchParams.get('planCode') || searchParams.get('plan');
  const capacity = Number(searchParams.get('capacity'));
  const durationMonths = Number(searchParams.get('durationMonths') || searchParams.get('duration'));
  const locale = searchParams.get('locale') || 'en';

  if (!Object.prototype.hasOwnProperty.call(PLAN_NAMES, plan)) return null;
  if (!Number.isSafeInteger(capacity) || capacity < 100) return null;
  if (!Number.isSafeInteger(durationMonths) || durationMonths < 1) return null;
  if (!['en', 'id'].includes(locale)) return null;

  return { plan, capacity, durationMonths, locale };
}

export function saveSessionValue(key, value) {
  sessionStorage.setItem(key, JSON.stringify(value));
}
